import ContentLoader from 'react-content-loader';
import Container from '@mui/material/Container';
import Page from 'components/system/Page';
import colors from 'styles/colors';
import { ContentLoading } from 'components/system/Loading';

const CompetitionLoader = ({ isMobile }) => (
  !isMobile ? (
    <Container>
      <Page sx={{ paddingTop: '24px !important' }}>
        <ContentLoader
          data-test-id="competition-loader"
          backgroundColor="rgba(0,96,250, 0.1)"
          foregroundColor="rgba(204,116,245, 0.3)"
          viewBox="0 0 380 250"
        >
          <rect x="0" y="1" rx="5" ry="5" width="100%" height="80" />

          <rect x="25%" y="90" rx="1" ry="1" width="30" height="12" />
          <rect x="35%" y="90" rx="1" ry="1" width="30" height="12" />
          <rect x="45%" y="90" rx="1" ry="1" width="30" height="12" />
          <rect x="55%" y="90" rx="1" ry="1" width="30" height="12" />
          <rect x="65%" y="90" rx="1" ry="1" width="30" height="12" />

          <rect x="0%" y="110" rx="3" ry="3" width="100%" height="160" />

        </ContentLoader>
      </Page>
    </Container>
  ) : (
    <Container sx={{ height: '100%', backgroundColor: colors.background.main }}>
      <Page sx={{ height: '100%', alignItems: 'center' }}>
        <ContentLoading />
      </Page>
    </Container>
  )
);

export default CompetitionLoader;
